module.exports = __webpack_public_path__ + "static/media/adult-image.86c64b79.png";